import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { RoomNumber as RoomNumberType } from '@/models/dashboard/dashboard-reservation'
import { formatRoomOccupancy } from '@/utils/format-room-occupancy'

type Props = {
  roomNumberAndPaxList: RoomNumberType[]
}

export const RoomNumberAndPaxCell: React.FC<Props> = ({ roomNumberAndPaxList }) => {
  const { t } = useTranslation()

  const renderPaxContent = useMemo(() => {
    return roomNumberAndPaxList.map(paxItem => {
      const paxText = formatRoomOccupancy(paxItem, t)

      return (
        <div key={paxItem.roomNumber} style={{ marginBottom: '8px' }}>
          <div style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '2px' }}>{paxItem.roomNumber}</div>
          <div style={{ fontSize: '10px', color: '#676767' }}>{paxText}</div>
        </div>
      )
    })
  }, [roomNumberAndPaxList, t])

  return <div className="pax-col">{renderPaxContent}</div>
}
